<div class="afy-popup" aria-hidden="true" [ngClass]="popupClasses" (click)="close($event)">
    <div class="afy-popup__content" [ngStyle]="{ 'max-width': popupMaxWidth }">
        <div class="afy-popup__wrapper Modal">
            <ng-content></ng-content>
        </div>
    </div>
</div>
